import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LuBell } from 'react-icons/lu';
import { IoIosArrowForward } from 'react-icons/io';

import { getUnreadCount } from 'services/notificationInbox.service';

/**
 * Ponto de entrada da central no Dashboard atual (CENTRAL-05.2).
 *
 * Autônoma em relação à `develop-novas-features` (CENTRAL-05.3): não depende de
 * nada daquela branch. Quando ela for mesclada, o "ver todas" da faixa nova passa
 * a apontar para `/notificacoes` e esta linha sai.
 *
 * Consulta o contador, não a lista: `get_notification_unread_count` resolve por
 * `COUNT_SCAN`, contando chaves do índice sem buscar documento nenhum — carregar
 * a lista para exibir um número seria pagar a caixa inteira no carregamento da
 * tela mais acessada do programa.
 *
 * Com zero não lidos a linha some. O acesso ao histórico continua pelo menu; uma
 * linha permanente dizendo "0" só ocuparia espaço na dobra mais disputada.
 *
 * Veste a casca dos demais cards do Dashboard (borda `electric-blue` sobre
 * `oxford-blue`) porque agora está no meio da pilha, não mais no rodapé: um
 * retângulo translúcido entre dois cards leria como falha de carregamento. O
 * destaque vem do amarelo e do sino, não de uma moldura fora do padrão.
 */
export function NotificationsRow() {
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      const total = await getUnreadCount();
      if (!cancelled) setUnread(total);
    }

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  if (unread === 0) return null;

  const plural = unread > 1;

  return (
    <Link
      to="/notificacoes"
      className="block border-2 border-electric-blue bg-oxford-blue rounded-2xl lg:rounded-[20px] px-6 lg:px-8 py-6 no-underline hover:ring-2 hover:ring-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow transition-shadow"
    >
      <span className="flex items-center justify-between gap-4">
        <span className="flex items-center gap-4">
          <span className="shrink-0 rounded-full bg-purple flex justify-center items-center w-10 h-10">
            <LuBell size={20} className="text-white" aria-hidden="true" />
          </span>
          <span className="text-white text-base lg:text-lg">
            Você tem{' '}
            <strong className="text-yellow font-bold">
              {unread} {plural ? 'notificações não lidas' : 'notificação não lida'}
            </strong>
          </span>
        </span>
        <span className="flex items-center gap-1 text-yellow text-sm shrink-0">
          <span className="hidden sm:inline">Ver todas</span>
          <IoIosArrowForward size={18} aria-hidden="true" />
        </span>
      </span>
    </Link>
  );
}
